import {formListMailInterfaces, formSendMailInterfaces} from '../services/edi';
import {deserialize, serialize} from '../serializers/edi';

import {formsStore} from '../../Form/stores/FormsStore';
import {EdiStore} from '../store/edi';

export async function getInterfacesList() {
    EdiStore.initStore();

    const data: any = await formListMailInterfaces(formsStore.currentForm);

    EdiStore.setInterfaces(deserialize(data));
}

export async function selectAll(selected: boolean) {
    EdiStore.setIsAllSelected(selected);
}

export async function setSearch(value: string) {
    EdiStore.setSearchValue(value);
}

export async function formMailInterfaces() {
    const data = serialize(EdiStore.interfaces, EdiStore.selected);
    await formSendMailInterfaces(formsStore.currentForm, EdiStore.sendAll, data);
}
